import {
    Box,
    SimpleGrid,
    Text,
} from "@chakra-ui/react";

import {
    Users,
    Wallet,
    Fingerprint,
    UserCog,
} from "lucide-react";

const categories = [
    {
        title: "Recruitment & Referrals",
        description:
            "Learn how to recruit drivers, share your referral code, and track referral progress.",
        icon: Users,
    },
    {
        title: "Commissions & Payouts",
        description:
            "Understand commission milestones, payout schedules, and payment methods.",
        icon: Wallet,
    },
    {
        title: "Referral Codes",
        description:
            "Find out how referral codes work and how drivers use them during registration.",
        icon: Fingerprint,
    },
    {
        title: "Partner Account",
        description:
            "Manage your profile, banking details, account settings, and verification information.",
        icon: UserCog,
    },
];

const KnowledgeBaseGrid = () => {
    return (
        <SimpleGrid
            columns={{
                base: 1,
                md: 2,
            }}
            gap={4}
        >
            {categories.map(
                (category) => (
                    <Box
                        key={category.title}
                        bg="white"
                        p={5}
                        borderRadius="12px"
                        border="1px solid"
                        borderColor="gray.200"
                        transition="all .2s"
                        cursor="pointer"
                        _hover={{
                            borderColor:
                                "#2453FF",
                            transform:
                                "translateY(-2px)",
                            shadow: "sm",
                        }}
                    >
                        <category.icon
                            size={18}
                            color="#2453FF"
                        />

                        <Text
                            mt={3}
                            mb={2}
                            fontWeight="700"
                            color="#071D54"
                        >
                            {category.title}
                        </Text>

                        <Text
                            fontSize="sm"
                            color="gray.500"
                            lineHeight="1.7"
                        >
                            {
                                category.description
                            }
                        </Text>
                    </Box>
                )
            )}
        </SimpleGrid>
    );
};

export default KnowledgeBaseGrid;